/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PermissionType } from '../models/PermissionType';

export class PermissionGrant {
  'permission': PermissionType;
  /**
  * Optional ID of the access condition associated with this permission grant. MUST be null for permissions where allowConditions=false.
  */
  'accessConditionId'?: string;
  /**
  * An optional list of scopes that further restrict the permission grant when a data access rule is applied.
  */
  'conditionalScopes'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "permission",
      "baseName": "permission",
      "type": "PermissionType",
      "format": ""
    },
    {
      "name": "accessConditionId",
      "baseName": "accessConditionId",
      "type": "string",
      "format": ""
    },
    {
      "name": "conditionalScopes",
      "baseName": "conditionalScopes",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PermissionGrant.attributeTypeMap;
  }

  public constructor() {
  }
}



